<template lang="html">
    <div class="multiselect-wrapper" v-bind:class="{ deactive: this.disabled }">
        <div class="v-select vs--searchable vs--open display-multiselect">
            <draggable
            v-model="this.value"
            @start="this.dragging = true"
            @end="this.dragging = false">
                <ul
                class="vs__selected vs__deselect selected-pills"
                v-for="(option, index) in this.options"
                v-bind:key="index">
                    <li>
                        {{ option }}
                        <button
                        v-on:click="deselect(index)"
                        type="button"
                        aria-label="deselect option"
                        class="vs__deselect"  >
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">
                                <path d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"
                                />
                            </svg>
                        </button>
                    </li>
                </ul>
            </draggable>
        </div>
        <v-select
        :label="this.label"
        multiple
        taggable
        push-tags="true"
        :options="this.options"
        v-model="this.value"
        v-bind:class="{ deactive: this.disabled }"/>
    </div>
</template>

<script>
export default {
    props: [
        "disabled",
        "options",
        "key",
        "valueKey",
        "label",
        "input",
        "value",
        "defaultOption"
    ],
    data() {
        return {
            dragging: false
        };
    },
    mounted() {
        console.log("optionss", this);
    },
    created: function() {
        console.log("options", this);
    }
};
</script>

<style lang="css" scoped>
</style>
